import axios from "axios";
import { api_url } from "../config";

const base_url = api_url;
export const uploadRmBuddies = async formData => {
  return axios.post(`${base_url}/RMBuddy/uploadMigrationData`, formData, {
    withCredentials: true
  });
};

export const updateRmBuddyProfile = async ({
  _id,
  name,
  mobileNumber,
  email
}) => {
  return axios.put(
    `${base_url}/RMBuddy/edit`,
    {
      _id,
      name,
      mobileNumber,
      email
    },
    {
      withCredentials: true
    }
  );
};

export const searchRmBuddies = async searchString => {
  return axios.get(`${base_url}/RMBuddy/getRmBuddies`, {
    params: {
      searchString
    },
    withCredentials: true
  });
};

export const getRmBuddiesByWarehouseId = async warehouseId => {
  return axios.get(`${base_url}/RMBuddy/listByWarehouse`, {
    params: {
      warehouseId
    },
    withCredentials: true
  });
};

export const getRmBuddiesByGeofence = async geofenceId => {
  return axios.get(`${base_url}/RMBuddy/getRmBuddies`, {
    params: {
      geofenceId
    },
    withCredentials: true
  });
};

export const removeFromGeofence = async ({ geofenceId, rmBuddyId }) => {
  return axios.put(
    `${base_url}/RMBuddy/removeFromGeofence`,
    {
      geofenceId,
      rmBuddyId
    },
    {
      withCredentials: true
    }
  );
};

export const assignToGeofence = async ({ geofenceId, rmBuddyId }) => {
  return axios.put(
    `${base_url}/RMBuddy/assignToGeofence`,
    {
      geofenceId,
      rmBuddyId
    },
    {
      withCredentials: true
    }
  );
};

export const getBuddyBlocksNamesFromWarehouseId = async warehouseId => {
  return axios.get(`${base_url}/geofence/buddyBlocksNames`, {
    params: {
      warehouseId
    },
    withCredentials: true
  });
};

export const getLeaves = async ({ rmBuddyId, fromDate, toDate }) => {
  return axios.get(`${base_url}/RMBuddy/getLeaves`, {
    params: {
      rmBuddyId,
      fromDate,
      toDate
    },
    withCredentials: true
  });
};

export const applyLeaves = async ({ rmBuddyId, fromDate, toDate }) => {
  return axios.post(
    `${base_url}/RMBuddy/addLeave`,
    {
      rmBuddyId,
      fromDate,
      toDate
    },
    {
      withCredentials: true
    }
  );
};

export const removeLeaves = async ({ rmBuddyId, fromDate, toDate }) => {
  return axios.post(
    `${base_url}/RMBuddy/removeLeave`,
    {
      rmBuddyId,
      fromDate,
      toDate
    },
    {
      withCredentials: true
    }
  );
};
